import Creditor from '@/views/creditor/Add.vue'

const router = {
    path: '/creditors/add',
    name: 'CreditorAdd',
    component: Creditor,
    meta: {
        title: 'Add Creditor'
    }
  };

export default router
